import { gql } from "@apollo/client";

export const ADD_FEEDBACK = gql`
  mutation createFeedback(
    $Year_ID: Float!
    $Vote_ID: Float!
    $LG_Vote_ID: Float!
    $SEPC_ID: Float!
    $Category: String!
    $Occurence_Rate: String!
    $Impact: String!
    $Description: String!
    $Image_url: String
    $Status: String!
    $Created_By: String!
    $Modified_By: String!
  ) {
    createFeedback(
      data: {
        Year_ID: $Year_ID
        Vote_ID: $Vote_ID
        LG_Vote_ID: $LG_Vote_ID
        SEPC_ID: $SEPC_ID
        Category: $Category
        Occurence_Rate: $Occurence_Rate
        Impact: $Impact
        Description: $Description
        Image_url: $Image_url
        Status: $Status
        Created_By: $Created_By
        Modified_By: $Modified_By
      }
    ) {
      Feedback_ID
      Year_ID

      Vote_ID {
        Vote_ID
        Vote_Code
        Vote_Name
      }

      LG_Vote_ID 
      SEPC_ID

      Ticket_No
      Category
      Occurence_Rate
      Impact
      Description
      Image_url
      Status
      Created_Date
      Modified_Date
      Created_By
      Modified_By
    }
  }
`;

/* export const UPDATE_FEEDBACK = gql`
  mutation updateFeedback(
    $Feedback_ID: Float!
    $Status: String!
    $Resolution_Summary: String!
    $Assigned_To: String!
    $Modified_By: String!
  ) {
    updateFeedback(
      id: $Feedback_ID
      data: {
        Status: $Status
        Resolution_Summary: $Resolution_Summary
        Assigned_To: $Assigned_To
        Modified_By: $Modified_By
      }
      
    ) {
      Feedback_ID
      Year_ID

      Vote_ID {
        Vote_ID
        Vote_Code
        Vote_Name
      }

      Ticket_No
      Category
      Occurence_Rate
      Impact
      Description
      Image_url
      Status
      Created_Date
      Modified_Date
      Created_By
      Modified_By
    }
  }
`; */
/* export const UPDATE_FEEDBACK = gql`
  mutation updateFeedback(
    $Feedback_ID: Float!
    $Status: String!
    $Resolution_Summary: String!
    $Assigned_To: String!
    $Modified_By: String!
  ) {
    updateFeedback(
      data: {
        Feedback_ID: $Feedback_ID
        Status: $Status
        Resolution_Summary: $Resolution_Summary
        Assigned_To: $Assigned_To
        Modified_By: $Modified_By
      }
    ) {
      Feedback_ID
      Ticket_No
      Status
      Assigned_To
      Resolution_Summary
      Modified_By
      Modified_Date
    }
  }
`; */

// In your mutations file
export const UPDATE_FEEDBACK = gql`
  mutation UpdateFeedback($id: Float!, $data: UpdateFeedbackInput!) {
    updateFeedback(id: $id, data: $data) {
      Feedback_ID
      Ticket_No
      Status
      Assigned_To
      Resolution_Summary
      Resolution_Type
      Modified_By
      Modified_Date
    }
  }
`;
export const DELETE_FEEDBACK = gql`
  mutation removeFeedback($Feedback_ID: Int!) {
    removeFeedback(id: $Feedback_ID) {
      Feedback_ID
      Ticket_No
    }
  }
`;